import React from 'react';
import * as ReactDOMClient from 'react-dom/client';

import './index.css';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import './styles/index.sass';
import Login from './components/Auth/Login';
import OfflineTutorial from './components/OfflineTutorial/OfflineTutorial';
import Summary from './components/Summary';
import InspectionPanel from './components/Inspection/components/InspectionPanel';
import NewInspection from './components/Inspection/components/NewInspection';
import Inspection from './components/Inspection/';
import InspectionSuccess from './components/Inspection/components/InspectionSuccess'

import { Provider } from 'react-redux';
import configureStore from './redux/store/store';
import IndexedDBService from './services/indexedDB/IndexedDB.service';
import inspectionUploadService from './components/Inspection/services/inspection-upload.service';
import SummarySuccess from './components/Summary/components/SummarySuccess/SummarySuccess';
import notificationService from './services/notification/notification.service';
import { SystemFlagsEnum } from './models/session/system-flags.enum';
import Sidebar from './global/sidebar/sidebar.container';
import InspectionProfile from './components/Inspection/components/InspectionProfile';
import InspectionLocation from './components/Inspection/components/InspectionLocation';
import { Box, createTheme, ThemeProvider } from '@mui/material';
import LoggedHeader from './components/Shared/LogedHeader/LogedHeader';

const theme = createTheme({
  typography: { fontFamily: '"Poppins", sans-serif' },
});

const routing = (
  <ThemeProvider theme={theme}>
  <Provider store={configureStore()}>
    <Router>
      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
      }}>
        <Sidebar />
        <LoggedHeader />
      </Box>
      <Switch>
        <Route exact path="/" component={OfflineTutorial} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/summary" component={Summary} />
        <Route exact path="/summary/success" component={SummarySuccess} />
        <Route exact path="/first-step" component={InspectionPanel} />
        <Route exact path="/new-inspection" component={NewInspection} />
        <Route exact path="/new-inspection/profile" component={InspectionProfile} />
        <Route exact path="/new-inspection/location" component={InspectionLocation} />
        <Route exact path="/inspection" component={Inspection} />
        <Route exact path="/InspectionSuccess" component={InspectionSuccess} />
      </Switch>
    </Router>
  </Provider>
  </ThemeProvider>
)

window.addEventListener('offline', function (e) {
  console.log('user desconnected');
});

window.addEventListener('online', function (e) {
  notificationService.notifyUploadStart();
  inspectionUploadService.getAllAwaitingPhotos();
});

window.addEventListener('beforeunload', (event) => {
  const isUploading = localStorage.getItem(SystemFlagsEnum.IS_UPLOADING_PHOTO) === '1';
  if (isUploading) {
    event.preventDefault();
    event.returnValue = '';
  }
  IndexedDBService.closeConnection();
});

const container = document.getElementById('root') || new HTMLElement();
const root = ReactDOMClient.createRoot(container);
root.render(
  routing
);

serviceWorkerRegistration.register({
  onUpdate: (registration: ServiceWorkerRegistration) => {
    const waiting = registration.waiting;
    if (!waiting) return;

    // eslint-disable-next-line no-alert
    if (window.confirm('Uma nova versão está disponível. Deseja atualizar agora?')) {
      waiting.postMessage({ type: 'SKIP_WAITING' });
      waiting.addEventListener('statechange', (e: Event) => {
        if ((e.target as ServiceWorker).state === 'activated') {
          window.location.reload();
        }
      });
    }
  },
});
reportWebVitals();

IndexedDBService.createdDB().then(() => {
  inspectionUploadService.recoverStuckUploads().finally(() => {
    if (window.navigator.onLine) {
      inspectionUploadService.getAllAwaitingPhotos();
    }
  });
});
